import { equalHeightTitle_EB } from "./equal-title-height.js";

(function ($) {
  $(document).ready(function () {
    let infinite_scroll = document.getElementById("infiniteScroll");
    let location_listing = document.getElementById("blog-listing");
    if (infinite_scroll && location_listing) {
      var executed = false;
      $(window).scroll(function () {
        var top_of_element = $("#blog-listing").offset().top;
        var bottom_of_element =
          $("#blog-listing").offset().top + $("#blog-listing").outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        var page = parseInt($("#infiniteScroll").attr("data-page"));
        var dataTotal = parseInt($("#infiniteScroll").attr("data-total-posts"));
        var offset = parseInt($("#infiniteScroll").attr("data-offset"));
        var category = $("#infiniteScroll").attr("data-category");

        if (
          bottom_of_screen > bottom_of_element &&
          $("#infiniteScroll").hasClass("unloaded") &&
          dataTotal > offset
        ) {
          if (!executed) {
            executed = true;
            page = page + 1;
            $("#infiniteScroll").attr("data-page", page);
            $.ajax({
              url: truecover_custom_data.ajax_url, // AJAX handler
              data: {
                action: "filter_location_category",
                category,
                page,
                offset,
                ajax_scroll: true,
              },
              type: "POST",
              dataType: "JSON",
              beforeSend: function () {
                $("#infinite_loader").css("display", "flex");
              },
              success: function (response) {
                executed = false;
                $("#infinite_loader").hide();
                $("#blog-listing").append(response.data.html);
                $("#infiniteScroll").attr(
                  "data-offset",
                  response.data.new_offset
                );
                if (response.data.more) {
                  $("#infiniteScroll").removeClass("unloaded");
                  executed = true;
                }

                equalHeightTitle_EB(
                  $(".blog-listing"),
                  $(".blog-post__content .entry-title"),
                  3
                );
              },
            });
          }
        }
      });
    }
  });
})(jQuery);
